import { render, staticRenderFns } from "./PasswordLayout.vue?vue&type=template&id=16578410"
import script from "./PasswordLayout.vue?vue&type=script&lang=js"
export * from "./PasswordLayout.vue?vue&type=script&lang=js"
import style0 from "./PasswordLayout.vue?vue&type=style&index=0&id=16578410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports